module.exports = __webpack_public_path__ + "img/107.1b6573e9.jpg";